import { useEffect } from "react";

export const exerciseDurationOptions = [180, 300, 600, 900] as const;

export function normalizeExerciseDurationSeconds(value: number) {
  return exerciseDurationOptions.reduce((nearest, option) => (
    Math.abs(option - value) < Math.abs(nearest - value) ? option : nearest
  ));
}

export function ExerciseDurationSelect({
  value,
  onChange,
  disabled = false,
  label = "Dauer",
  maxSeconds = 900,
}: {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  label?: string;
  maxSeconds?: 600 | 900;
}) {
  const normalizedValue = Math.min(maxSeconds, normalizeExerciseDurationSeconds(value));

  useEffect(() => {
    if (value !== normalizedValue) onChange(normalizedValue);
  }, [normalizedValue, onChange, value]);

  return (
    <label>
      {label}
      <select disabled={disabled} value={normalizedValue} onChange={(event) => onChange(Number(event.target.value))}>
        {exerciseDurationOptions.filter((seconds) => seconds <= maxSeconds).map((seconds) => (
          <option value={seconds} key={seconds}>{seconds / 60} Minuten</option>
        ))}
      </select>
    </label>
  );
}


/** A reminder only: elapsed time never ends a flashcard run. */
export function FlashcardTimerSelect({ value, onChange, disabled = false }: { value: number; onChange: (value: number) => void; disabled?: boolean }) {
  return <label>Freiwilliger Timer<select value={value} disabled={disabled} onChange={(event) => onChange(Number(event.target.value))}>
    <option value={0}>Aus</option>
    {[300, 600, 900].map((seconds) => <option key={seconds} value={seconds}>{seconds / 60} Minuten</option>)}
  </select></label>;
}
